import { IN_PERSON_TRAINING } from 'constants/actionTypes';
import { routes } from 'constants/config';
import createActionsCreators from 'utils/createActionsCreators';
import request from 'utils/request_ajax';
import serializeUrl from 'utils/serialize_url';

const actions = createActionsCreators({
  addItem: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.ADD_ITEM,
  dataRequest: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_REQUEST,
  dataSuccess: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_SUCCESS,
  dataFailure: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.DATA_FAILURE,
  setActionMessage: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.SET_ACTION_MESSAGE,
  removeItem: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.REMOVE_ITEM,
  removeFailure: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.REMOVE_FAILURE,
  assignContent: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.ASSIGN_CONTENT,
  assignEventContent: IN_PERSON_TRAINING.ASSOCIATED_CONTENT.ASSIGN_CONTENT,
});

const normalizeContentItems = data => {
  if (!data) {
    return data;
  }
  const normalizedData = [...data];
  normalizedData.forEach(item => {
    item.association_id = item.id;
    item.id = item.content.id;
    item.type = item.content.type;
    item.content = null;
  });

  return normalizedData;
};

export const getAssociatedContent = sessionId => {
  return (dispatch, getState) =>
    new Promise(resolve => {
      dispatch(actions.dataRequest());
      const { event, sessions } = getState();
      request
        .get(
          serializeUrl(
            routes.IN_PERSON_TRAINING.ASSOCIATED_CONTENTS(
              event.id,
              sessionId || sessions[sessions.length - 1].id,
            ),
          ),
        )
        .then(data => {
          dispatch(actions.dataSuccess(normalizeContentItems(data)));
          resolve();
        })
        .catch(error => {
          dispatch(actions.dataFailure(error));
        });
    });
};

export const removeAssociatedContentItem = associationId => {
  return (dispatch, getState) =>
    new Promise(resolve => {
      const { event, sessions } = getState();
      request
        .delete(
          serializeUrl(
            routes.IN_PERSON_TRAINING.REMOVE_ASSOCIATED_CONTENT_ITEM(
              event.id,
              sessions[sessions.length - 1].id,
              associationId,
            ),
          ),
        )
        .then(() => {
          dispatch(actions.removeItem(associationId));
          resolve();
        })
        .catch(error => {
          dispatch(actions.removeFailure({ error, associationId }));
        });
    });
};

export const addAssociatedContentItem = (contentItem, sessionId) => {
  const { id, type } = contentItem;
  const addItem = { contents: [{ id, type }] };

  return (dispatch, getState) =>
    new Promise(resolve => {
      const { event, sessions } = getState();
      dispatch(actions.dataFailure());
      request
        .postJSON(
          serializeUrl(
            routes.IN_PERSON_TRAINING.ADD_ASSOCIATED_CONTENT(
              event.id,
              sessionId || sessions[sessions.length - 1].id,
            ),
          ),
          addItem,
        )
        .then(data => {
          dispatch(actions.addItem(normalizeContentItems(data)));
        })
        .catch(error => {
          dispatch(actions.dataFailure(error));
        });
    });
};

export const assignContent = (sessionId, assigneeId) => {
  return (dispatch, getState) =>
    new Promise(resolve => {
      const { event, sessions } = getState();
      request
        .postJSON(
          serializeUrl(
            routes.IN_PERSON_TRAINING.ASSIGN_CONTENT(
              event.id,
              sessionId || sessions[sessions.length - 1].id,
            ),
          ),
        )
        .then(() => dispatch(actions.assignContent(assigneeId)))
        .catch(error => {
          dispatch(actions.dataFailure(error));
        });
    });
};

export function assignSessionContent(
  schedule,
  existingAssignments,
  message,
  sessionId,
  assigneeId,
) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      const { event, sessions } = getState();
      const assignment = {
        assign: {
          event_id: event.id,
          session_id: sessionId || sessions[sessions.length - 1].id,
          schedule,
          existingAssignments,
          message,
        },
      };

      request
        .postJSON(
          serializeUrl(
            routes.IN_PERSON_TRAINING.ASSIGN_CONTENT(
              event.id,
              sessionId || sessions[sessions.length - 1].id,
            ),
          ),
          assignment,
        )
        .then(data => {
          if (data.success) {
            dispatch(actions.assignContent(assigneeId));
            window.location.reload();
            resolve();
          }
        })
        .fail(reject);
    });
}
